import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
// NOTE: the path above looks weird, but it's necessary, since we need to reference
// a path outside of the dist folder in which component resides when built for production
import LogoHuge from '../../../src/assets/cata_style_images/logo-huge.svg';
import { useI18n } from '../I18n';
import * as styles from './BrandLogo.module.scss';
import { SmallLogo } from './SmallLogo';
export const BrandLogo = ({ small, className, alt, ...props }) => {
    const i18n = useI18n();
    return (_jsxs("a", { className: cn(styles.wrapper, className, { [styles.small]: small }), title: alt ?? i18n.t('catawiki'), ...props, children: [_jsx("img", { className: styles.logo, src: LogoHuge, "aria-hidden": "true", alt: "" }), _jsx(SmallLogo, { className: cn(styles.smallLogo, 'u-w-full'), "aria-hidden": "true", alt: "" })] }));
};
//# sourceMappingURL=BrandLogo.js.map